const getBaseURL = () => {
    if ( process.env.REACT_APP_LOCAL === '2' )
        return 'http://localhost:3005';
    
    else {
        switch( process.env.REACT_APP_ENVIRONMENT ) {
            case 'dev':
                return process.env.REACT_APP_BASE_URL_DEV;
            case 'staging':
                return process.env.REACT_APP_BASE_URL_STAGING;
            case 'prod':
                return process.env.REACT_APP_BASE_URL_PROD;
        }
    }
    throw new Error('LOCAL or ENVIRONMENT variable error.') 
}


export default getBaseURL